<template>
    <el-config-provider :locale="locale">
        <div v-if="appStore.routerLoading" class="router-loading">
            <div class="loading-spinner"></div>
        </div>
        <RouterView />
    </el-config-provider>

</template>
<script>
import { defineComponent } from 'vue'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { useAppStore } from '@/store'

export default defineComponent({
    components: {
        ElConfigProvider,
    },
    setup() {
        const appStore = useAppStore()
        return {
            locale: zhCn,
            appStore,
        }
    },
})
</script>
<style lang='scss'>
.img {
  display: flex;
  flex-wrap: wrap;

  & > a {
    width: 30px;
    height: 30px;
    margin: 3px;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.avatar-uploader{

  .el-upload{
    width: 100px;
    height: 100px;
    &>img{
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

}
.router-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #409eff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
